import type { Customer } from '@setapart/shared';
import { clearBrandToken, getBrandToken, setBrandToken } from './session';

declare const __AUTH_BASE__: string;
declare const __OAUTH_BASE__: string;
declare const __API_BASE__: string;

export const AUTH_BASE: string = typeof __AUTH_BASE__ === 'string' ? __AUTH_BASE__ : '';
export const OAUTH_BASE: string = typeof __OAUTH_BASE__ === 'string' ? __OAUTH_BASE__ : '';
export const API_BASE: string = typeof __API_BASE__ === 'string' ? __API_BASE__ : '';

function authHeaders(extra: Record<string, string> = {}): Record<string, string> {
  const t = getBrandToken();
  const h = { ...extra };
  if (t) h['Authorization'] = `Bearer ${t}`;
  return h;
}

export async function me(): Promise<{ ok: true; customer: Customer | null }> {
  const res = await fetch(`${AUTH_BASE}/auth/me`, { credentials: 'include', headers: authHeaders() });
  if (!res.ok) return { ok: true, customer: null };
  return (await res.json()) as { ok: true; customer: Customer | null };
}

export async function requestMagicLink(email: string) {
  const res = await fetch(`${AUTH_BASE}/auth/request`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, redirect: window.location.origin + '/dashboard' }),
  });
  return (await res.json()) as { ok: boolean; error?: string; devMagicLink?: string };
}

export async function verify(token: string) {
  const res = await fetch(`${AUTH_BASE}/auth/verify`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token }),
  });
  const body = (await res.json()) as { ok: boolean; error?: string; customer?: Customer; token?: string };
  if (body.ok && body.token) setBrandToken(body.token);
  return { ok: body.ok, error: body.error, customer: body.customer };
}

export async function logout() {
  await fetch(`${AUTH_BASE}/auth/logout`, { method: 'POST', credentials: 'include', headers: authHeaders() });
  clearBrandToken();
}

export function connectShopifyUrl(brandId: string, shop: string): string {
  const u = new URL(`${OAUTH_BASE}/connect/start`);
  u.searchParams.set('brand_id', brandId);
  u.searchParams.set('shop', shop);
  return u.toString();
}
